import type { AxiosInstance } from 'axios';
import type { SubscriptionEventsUseCases } from '@subscriptions/composition/types';
import { createSubscriptionEventsHttpClient } from '@subscriptions/infrastructure/api/SubscriptionEventsHttpClient';
import { createSubscriptionEventsApiMapper } from '@subscriptions/infrastructure/mappers/SubscriptionEventsApiMapper';
import { createSubscriptionEventsApiRepository } from '@subscriptions/infrastructure/repositories/SubscriptionEventsApiRepository';
import { listSubscriptionEventsUseCase } from '@subscriptions/application/use-cases';

/**
 * Assembles all collection-status event use cases with their dependencies.
 *
 * @param httpClientSubscription - Axios bound to parrot-subscriptions-api
 */
export const createSubscriptionEventsUseCases = (httpClientSubscription: AxiosInstance): SubscriptionEventsUseCases => {
  const eventsHttpClient = createSubscriptionEventsHttpClient({ httpClientSubscription });
  const mapper = createSubscriptionEventsApiMapper();
  const repository = createSubscriptionEventsApiRepository({ httpClient: eventsHttpClient, mapper });

  return {
    listSubscriptionEvents: listSubscriptionEventsUseCase(repository),
  };
};
